import apiClient from './apiClient';

/**
 * Per-hotel scheduled reminder emails (check-in / check-out).
 *
 * Config lives in reservations.ReminderEmailTemplate on the backend; the
 * scheduler ticks once a minute and sends each reminder at
 * sendOffsetMinutes before the hotel's check-in/check-out time
 * (hotel-local). Attachments (poster images, PDFs) ride on every send.
 */
const reminderEmailService = {
  get: () => apiClient.get('/v1/settings/reminder-emails'),
  update: (data) => apiClient.put('/v1/settings/reminder-emails', data),
  uploadAttachment: (kind, file) => {
    const fd = new FormData();
    fd.append('kind', kind);
    fd.append('file', file);
    return apiClient.postForm('/v1/settings/reminder-emails/attachments', fd);
  },
  deleteAttachment: (id) => apiClient.del(`/v1/settings/reminder-emails/attachments/${id}`),
  // Renders against a real reservation and emails a preview — never
  // touches the once-only dispatch ledger. `draft` ({subject, bodyHtml})
  // tests what's typed on screen without saving it, like the SMTP test.
  sendSample: (kind, to, draft) =>
    apiClient.post('/v1/settings/reminder-emails/sample', { kind, to, ...(draft || {}) }),
  // What the scheduler actually did, plus upcoming arrivals that carry no
  // email address and so cannot receive anything.
  getActivity: () => apiClient.get('/v1/settings/reminder-emails/activity'),
  // Version history: every saved state of a kind's subject/message (incl.
  // language versions). Restoring is itself recorded, so it can be undone.
  getRevisions: (kind) => apiClient.get(`/v1/settings/reminder-emails/revisions?kind=${kind}`),
  getRevision: (id) => apiClient.get(`/v1/settings/template-revisions/${id}`),
  restoreRevision: (id) => apiClient.post(`/v1/settings/template-revisions/${id}/restore`, {}),
};

export default reminderEmailService;
